<template>
  <div class="rule-form-step rule-form-step--scaling-up rule-form-step--scaling-up--step-2 flex max-w-4xl flex-col gap-5 py-5">
    <campaign-name-block :entity="entity" :disabled="!entity.isNew" />

    <campaign-budget-block
      :entity="entity"
      :disabled="$parent.readonlyMode"
      switchable
    />
  </div>
</template>

<script>
import RuleFormStepMixin from '@/mixins/RuleForm/Step.js';
import CampaignBudgetBlock from '@/ui/components/RuleForm/Blocks/CampaignBudgetBlock.vue';
import CampaignNameBlock from '@/ui/components/RuleForm/Blocks/CampaignNameBlock.vue';

export default {
  name: 'ScalingUpRuleFormStep2',
  components: {
    CampaignBudgetBlock,
    CampaignNameBlock,
  },
  mixins: [ RuleFormStepMixin ],
};
</script>
